module.exports = __webpack_public_path__ + "static/img/dw02.799446c2.jpg";